import { DeckDef } from "../types";

// Decki #2, #4, #5, #6 — na razie stuby (slajd tytułowy). Treść budujemy po kolei.

export const howItWorksDeck: DeckDef = {
  id: "how-it-works",
  slug: "jak-dziala",
  title: "Jak to działa",
  subtitle: "Mechanizm krok po kroku — po ludzku",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 18,
  ready: true,
  slides: [
    {
      id: "hero",
      tone: "brand",
      scene: "flow-hero",
      logo: "/LBP_Logo_White.svg",
      title: "Jak to *działa*",
      lead: "Od oddania głosu do dowodu, którego nie da się podrobić — krok po kroku.",
      durationSec: 40,
      notes:
        "Otwarcie: obiecujemy proste, krok-po-kroku wyjaśnienie. Bez żargonu — każdy laik wyjdzie z tego z intuicją, jak to działa."
    },
    {
      id: "overview",
      scene: "vote-flow",
      kicker: "W skrócie",
      title: "Od głosu do dowodu — w *czterech krokach*",
      lead: "Głos → cyfrowy odcisk → pieczęć na łańcuchu → publiczna weryfikacja.",
      terms: [
        { term: "hash", gloss: "cyfrowy odcisk" },
        { term: "blockchain", gloss: "niezmienialny rejestr" }
      ],
      durationSec: 65,
      notes:
        "Mapa całości: cztery kroki. Reszta decku rozwija każdy z nich. Powiedz, że to jeden płynny proces, który zaraz rozłożymy na części."
    },
    {
      id: "step-vote",
      scene: "step-vote",
      kicker: "Krok 1",
      title: "Oddajesz głos *z telefonu*",
      lead: "Wybierasz opcję w aplikacji lub przeglądarce — prosto, jak w bankowości.",
      durationSec: 50,
      notes:
        "Krok 1 jest banalny dla użytkownika: kilka kliknięć. Cała magia dzieje się dalej, w tle — co pokazujemy w kolejnych krokach."
    },
    {
      id: "step-hash",
      scene: "step-hash",
      kicker: "Krok 2",
      title: "Głos dostaje *cyfrowy odcisk*",
      lead: "System tworzy z głosu unikalny „odcisk palca” (hash) — zmiana jednej litery daje zupełnie inny odcisk.",
      terms: [{ term: "hash", gloss: "cyfrowy odcisk głosu" }],
      durationSec: 60,
      notes:
        "Metafora odcisku palca: każdy głos ma swój unikalny ślad. Najmniejsza zmiana treści = całkiem inny odcisk, więc podmiana od razu się wydaje."
    },
    {
      id: "step-seal",
      scene: "step-seal",
      kicker: "Krok 3",
      title: "Odcisk trafia na *łańcuch*",
      lead: "Odcisk zostaje zapieczętowany w bloku łańcucha — trwale i bez możliwości cichej zmiany.",
      terms: [{ term: "blockchain", gloss: "niezmienialny, publiczny rejestr" }],
      durationSec: 60,
      notes:
        "Pieczęć na łańcuchu: od tej chwili odcisku nie da się po cichu zmienić ani usunąć. To jest moment, w którym wynik staje się „zabetonowany”."
    },
    {
      id: "verify",
      scene: "verify-lights",
      kicker: "Krok 4",
      title: "Każdy sprawdzi, że *wynik się zgadza*",
      lead: "Potwierdzasz, że łączny wynik jest prawdziwy i nienaruszony — nie widząc, jak zagłosował ktokolwiek.",
      bullets: [
        "Sprawdzasz uczciwość wyniku, a nie pojedyncze głosy.",
        "Weryfikuje głosujący, dziennikarz i urząd — bez zaufania na słowo."
      ],
      durationSec: 55,
      notes:
        "Krok 4 domyka pętlę zaufania: dowód jest publiczny, więc każdy może niezależnie potwierdzić wynik. Nie trzeba wierzyć operatorowi."
    },
    {
      id: "modes",
      scene: "two-modes",
      kicker: "Dwa tryby",
      title: "*Tajny* albo *jawny* głos",
      lead: "Tajny: wiadomo, ŻE ktoś zagłosował, nie JAK (ZKP). Jawny: głos widoczny pojedynczo w eksploratorze.",
      terms: [
        { term: "ZKP", gloss: "dowód bez ujawniania" },
        { term: "eksplorator", gloss: "publiczny podgląd łańcucha" }
      ],
      durationSec: 65,
      notes:
        "Pokaż, że mechanizm obsługuje oba światy: głosowania tajne (z ochroną prywatności) i jawne (pełna przejrzystość). Organizator wybiera, co pasuje."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Zobacz to *na żywo*",
      lead: "Najlepiej pokazać mechanizm w działaniu — zaprezentujemy i przygotujemy pilotaż.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes:
        "Zamknięcie: zaproszenie do demonstracji na żywo. „Jak to działa” najlepiej zrozumie się, widząc to w akcji."
    }
  ]
};

export const securityDeck: DeckDef = {
  id: "security",
  slug: "bezpieczenstwo",
  title: "Bezpieczeństwo i tajność głosu",
  subtitle: "Jak gwarantujemy prywatność i odporność na manipulację",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 18,
  ready: true,
  slides: [
    {
      id: "hero",
      tone: "brand",
      scene: "secret-hero",
      logo: "/LBP_Logo_White.svg",
      title: "Bezpieczeństwo i *tajność* głosu",
      lead: "Wiadomo, ŻE ktoś zagłosował — nie wiadomo JAK. A wynik i tak da się sprawdzić.",
      durationSec: 40,
      notes:
        "Otwarcie: stawiamy tezę, która brzmi jak sprzeczność — pełna tajność i pełna weryfikowalność naraz. Reszta decku pokazuje, że to możliwe dzięki kryptografii."
    },
    {
      id: "paradox",
      scene: "paradox",
      kicker: "Pozorna sprzeczność",
      title: "Tajne, a jednak *sprawdzalne*",
      lead: "Zwykle coś jest albo tajne, albo weryfikowalne. My łączymy jedno i drugie — dzięki kryptografii.",
      bullets: [
        "Tajność: nikt nie powiąże głosu z konkretną osobą.",
        "Weryfikowalność: każdy potwierdzi, że wynik jest prawdziwy."
      ],
      terms: [{ term: "kryptografia", gloss: "matematyka zabezpieczeń" }],
      durationSec: 65,
      notes:
        "Nazwij napięcie wprost: ludzie zakładają, że tajność wyklucza sprawdzalność. Pokaż, że to fałszywy wybór — można mieć oba."
    },
    {
      id: "zkp",
      scene: "zkp-witness",
      kicker: "Jak to możliwe — ZKP",
      title: "Świadek, który *nie patrzy w kartę*",
      lead: "Dowód z wiedzą zerową potwierdza, że głos jest ważny i pojedynczy — nie ujawniając jego treści.",
      terms: [{ term: "ZKP", gloss: "dowód bez ujawniania" }],
      durationSec: 70,
      notes:
        "Metafora: świadek, który zaświadcza „ten głos jest ważny i jeden”, ale nie zagląda do karty. To jest sedno ZKP — dowód bez ujawniania treści."
    },
    {
      id: "nullifier",
      scene: "nullifier",
      kicker: "Bez podwójnego głosu",
      title: "Jeden głos, *nie dwa*",
      lead: "Każdy uprawniony głosuje raz. Próba drugiego głosu jest odrzucana — bez ujawniania, kto próbował.",
      terms: [{ term: "nullifier", gloss: "znacznik „już zagłosowano”" }],
      durationSec: 60,
      notes:
        "Wyjaśnij, że anonimowość nie oznacza chaosu: system wie, że dany uprawniony już oddał głos (i blokuje drugi), nie wiedząc, jak zagłosował."
    },
    {
      id: "separation",
      scene: "separation",
      kicker: "Rozdział danych",
      title: "Kto głosował *≠* jak głosował",
      lead: "Lista uprawnionych i oddane głosy są trzymane osobno — nie istnieje mapowanie „osoba → wybór”.",
      durationSec: 60,
      notes:
        "Architektura prywatności: rozdzielamy „uczestnictwo” od „treści głosu”. Nawet my nie odtworzymy, kto jak głosował."
    },
    {
      id: "tamper",
      scene: "verify-lights",
      kicker: "Odporność",
      title: "Manipulacja *zostawia ślad*",
      lead: "Każda zmiana wyniku jest natychmiast wykrywalna — zielone „zgodne”, czerwone „zmiana”.",
      bullets: [
        "Brak cichej podmiany — dowód jest publiczny.",
        "Odporność na pojedynczy punkt awarii (węzły 2-z-3)."
      ],
      durationSec: 60,
      notes:
        "Tajność nie osłabia bezpieczeństwa wyniku: każda ingerencja jest wykrywalna, a brak jednego serwera nie wyłącza systemu."
    },
    {
      id: "privacy",
      scene: "privacy-shield",
      kicker: "Prywatność",
      title: "Prywatność *z założenia*",
      lead: "Zbieramy minimum danych, szyfrujemy i przetwarzamy zgodnie z RODO — w Polsce i UE.",
      terms: [
        { term: "privacy by design", gloss: "prywatność wbudowana" },
        { term: "RODO", gloss: "unijna ochrona danych" }
      ],
      durationSec: 55,
      notes:
        "Prywatność nie jest dodatkiem, tylko fundamentem projektu: minimalizacja danych, szyfrowanie, zgodność z RODO, dane w UE."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Pokażemy to *na żywo*",
      lead: "Zaprezentujemy mechanizm tajności i weryfikacji oraz przygotujemy pilotaż.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes:
        "Zamknięcie: zaproszenie do demonstracji mechanizmu i pilotażu. Bezpieczeństwo najlepiej pokazać na żywo."
    }
  ]
};

export const sovereigntyDeck: DeckDef = {
  id: "sovereignty",
  slug: "suwerennosc",
  title: "Suwerenność cyfrowa",
  subtitle: "Własny łańcuch, otwarty kod, zero zależności od obcych dostawców",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 12,
  ready: true,
  slides: [
    {
      id: "hero",
      tone: "brand",
      scene: "sovereign-hero",
      logo: "/LBP_Logo_White.svg",
      title: "Suwerenność *cyfrowa*",
      lead: "Polski łańcuch, otwarty kod, niezależne węzły — wybory bez zależności od obcych dostawców.",
      durationSec: 40,
      notes:
        "Otwarcie pod państwo. Jedno zdanie: infrastruktura wyborcza może być w pełni polska i niezależna. Tarcza + własna sieć węzłów na grafice budują „narodowy” ton."
    },
    {
      id: "problem",
      scene: "foreign-dep",
      kicker: "Problem",
      title: "Cudza technologia = *cudza kontrola*",
      lead: "Gdy system wyborczy stoi na zagranicznej, zamkniętej platformie, państwo oddaje kontrolę i dane w obce ręce.",
      bullets: [
        "Zamknięty kod — nie wiadomo, co naprawdę robi system.",
        "Dane i serwery poza krajem, pod obcą jurysdykcją.",
        "Zależność od dostawcy, którego nie kontrolujemy."
      ],
      terms: [{ term: "vendor lock-in", gloss: "uzależnienie od jednego dostawcy" }],
      durationSec: 70,
      notes:
        "Pokaż ryzyko strategiczne: oddanie krytycznej infrastruktury w obce, zamknięte ręce. To nie jest argument anty-zagraniczny, tylko o KONTROLI nad procesem wyborczym."
    },
    {
      id: "own-chain",
      scene: "own-chain",
      kicker: "Nasz fundament",
      title: "*Własny* łańcuch Fundacji",
      lead: "Rejestr wyników należy do polskiej Fundacji — nie do zagranicznej korporacji.",
      terms: [{ term: "blockchain", gloss: "niezmienialny, publiczny rejestr" }],
      durationSec: 55,
      notes:
        "Fundament suwerenności: my władamy łańcuchem, jego źródłem i autorytetem. Nie wynajmujemy cudzej infrastruktury — mamy własną."
    },
    {
      id: "open-code",
      scene: "open-code",
      kicker: "Otwartość",
      title: "Otwarty kod — *każdy sprawdzi*",
      lead: "Kod węzła jest jawny. Niezależni eksperci mogą go zweryfikować — żadnych ukrytych mechanizmów.",
      terms: [
        { term: "open source", gloss: "jawny, otwarty kod" },
        { term: "audyt", gloss: "niezależna kontrola kodu" }
      ],
      durationSec: 60,
      notes:
        "Otwarty kod = brak „czarnej skrzynki”. Każdy ekspert, uczelnia czy instytucja może skontrolować, co system robi. Przeciwieństwo zamkniętych, zagranicznych rozwiązań."
    },
    {
      id: "nodes",
      scene: "node-cluster",
      kicker: "Niezależne węzły",
      title: "Trzy węzły, zasada *2-z-3*",
      lead: "Łańcuch utrzymują niezależne węzły. Żaden pojedynczy podmiot nie kontroluje wyniku — i każdy może postawić własny.",
      bullets: [
        "Wynik potwierdzają co najmniej 2 z 3 niezależnych węzłów.",
        "Urząd, uczelnia czy organizacja może uruchomić swój węzeł i weryfikować."
      ],
      terms: [
        { term: "węzeł", gloss: "niezależny serwer łańcucha" },
        { term: "konsensus", gloss: "zgoda węzłów co do wyniku" }
      ],
      durationSec: 75,
      notes:
        "Decentralizacja po polsku: wynik nie zależy od jednej maszyny ani jednej firmy. Zasada 2-z-3 + możliwość postawienia własnego węzła = realna kontrola rozproszona."
    },
    {
      id: "data",
      scene: "data-pl",
      kicker: "Dane",
      title: "Dane zostają *w Polsce i UE*",
      lead: "Przetwarzanie na terenie kraju i Unii — zgodnie z RODO, pod polską i unijną jurysdykcją.",
      terms: [
        { term: "RODO", gloss: "unijna ochrona danych" },
        { term: "jurysdykcja", gloss: "czyje prawo obowiązuje" }
      ],
      durationSec: 55,
      notes:
        "Dane obywateli nie wyciekają poza UE ani pod obce prawo. To konkret, który rozumie każdy urząd i dział prawny."
    },
    {
      id: "state",
      scene: "institution",
      kicker: "Co to daje państwu",
      title: "Niezależność to *bezpieczeństwo państwa*",
      bullets: [
        "Pełna kontrola nad krytyczną infrastrukturą wyborczą.",
        "Odporność na naciski i awarie zewnętrznych dostawców.",
        "Wiarygodność: rozwiązanie polskie, jawne i weryfikowalne."
      ],
      durationSec: 65,
      notes:
        "Podsumowanie w języku racji stanu: suwerenność cyfrowa = bezpieczeństwo i wiarygodność instytucji. Nikt z zewnątrz nie może „wyłączyć” ani podejrzeć procesu."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Zbudujmy to *po polsku*",
      lead: "Pokażemy architekturę i zaproponujemy pilotaż w pełni pod polską kontrolą.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes:
        "Zamknięcie: propozycja wspólnej budowy/pilotażu pod polską kontrolą. Niskie ryzyko, pełna suwerenność. Zostaw kontakt."
    }
  ]
};

export const organizationsDeck: DeckDef = {
  id: "organizations",
  slug: "organizacje",
  title: "Dla organizacji i wspólnot",
  subtitle: "Proste, mobilne głosowania w NGO, wspólnotach i na uczelniach",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 12,
  ready: true,
  slides: [
    {
      id: "hero",
      tone: "brand",
      scene: "community-hero",
      logo: "/LBP_Logo_White.svg",
      title: "Głosowania dla *organizacji i wspólnot*",
      lead: "Wybory zarządu, uchwały, ankiety — wygodnie z telefonu, z wiarygodnym wynikiem.",
      durationSec: 40,
      notes: "Otwarcie pod organizacje: damy proste narzędzie do każdego głosowania w organizacji, którym członkowie zaufają."
    },
    {
      id: "problem",
      scene: "paper-pain",
      kicker: "Problem",
      title: "Zbieranie głosów to *udręka*",
      lead: "Kartki, podpisy, liczenie ręczne i wieczne pytanie: czy mamy kworum?",
      bullets: [
        "Niska frekwencja — część członków nie dotrze na zebranie.",
        "Ręczne liczenie i papierologia pochłaniają czas.",
        "Wynik łatwo zakwestionować."
      ],
      durationSec: 65,
      notes: "Ból znany każdej wspólnocie i stowarzyszeniu: papier, kworum, ręczne liczenie i spory o wynik."
    },
    {
      id: "uses",
      kicker: "Po co",
      title: "Wybory, uchwały, *ankiety*",
      pillars: [
        { title: "Wybory zarządu", text: "Głosowania osobowe — jawne lub tajne, z natychmiastowym wynikiem.", icon: "FiUsers" },
        { title: "Uchwały i decyzje", text: "Za / przeciw / wstrzymanie — policzone automatycznie i udokumentowane.", icon: "FiCheckCircle" },
        { title: "Ankiety i konsultacje", text: "Pytania do członków, opinie zebrane w jednym miejscu.", icon: "FiActivity" }
      ],
      durationSec: 75,
      notes: "Trzy najczęstsze potrzeby organizacji. Jedno narzędzie do wszystkich."
    },
    {
      id: "who",
      scene: "org-types",
      kicker: "Dla kogo",
      title: "Wspólnoty, stowarzyszenia, *uczelnie*",
      lead: "Spółdzielnie, związki, koła naukowe, rady — wszędzie, gdzie liczy się głos członków.",
      durationSec: 50,
      notes: "Pokaż szerokość: od wspólnoty mieszkaniowej, przez stowarzyszenia, po uczelnie i spółdzielnie."
    },
    {
      id: "mobile",
      scene: "step-vote",
      kicker: "Proste i mobilne",
      title: "Głosujesz *z telefonu*",
      lead: "Bez zebrań i kartek — link do głosowania trafia do członków, a kworum osiągasz łatwiej.",
      durationSec: 55,
      notes: "Frekwencja rośnie, gdy głosowanie jest pod ręką. Mniej organizacji zebrań, więcej oddanych głosów."
    },
    {
      id: "trust",
      scene: "verify-lights",
      kicker: "Wiarygodność",
      title: "Wynik, którego *nikt nie podważy*",
      lead: "Każdy członek potwierdzi, że łączny wynik jest prawdziwy — a głosy mogą pozostać tajne.",
      terms: [{ term: "blockchain", gloss: "niezmienialny rejestr" }],
      durationSec: 55,
      notes: "Koniec ze sporami o wynik: dowód jest publiczny, a tajność głosu zachowana."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Przetestujmy w *Twojej organizacji*",
      lead: "Wybierzmy jedno głosowanie — pokażemy, jak to działa u Was, przy minimalnym wysiłku.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes: "Zamknięcie: niskoryzykowny pilotaż na jednym głosowaniu organizacji."
    }
  ]
};
